// sortBy Mobilde is useless?
$('#SortBy-mobile, #SortBy').on('change', function () {
  const url = new URL(location.href);
  const handle = url.pathname.split('/').pop();
  const splitedHandle = handle.split('__');
  const collectionName = splitedHandle[0];
  const sortType = splitedHandle.pop();
  const sortVal = $(this).val();
  if (sortVal !== sortType) {
    const redirectUrl = '/collections/' + collectionName + '__' + sortVal;
    location.href = redirectUrl;
  }
});
